import React from 'react';
import {
  calculateAndFormatUnixDates,
  futureDate,
  getCurrentDate,
} from '../../../../utils/dates/date-utility';
import words from '../../../../utils/words';
import { isSell } from '../../../../utils/transactions-util';

const AddressChangePendingFundNoteTip = ({
  fund: {
    addressChangedSameDay,
    address: { effectiveDate },
  },
}) => (
  <div className="exclude">
    {isSell()
      ? `You may submit an online ${words.redemption} and have the proceeds delivered
    by check once pending address change is complete on`
      : `Available for ${words.redemption} online once pending address change is
    complete on`}{' '}
    {addressChangedSameDay
      ? calculateAndFormatUnixDates(futureDate(getCurrentDate(), 15))
      : calculateAndFormatUnixDates(futureDate(effectiveDate, 15))}
    . Please{' '}
    <a
      href="https://www.troweprice.com/personal-investing/help/contact/index.html"
      target="_blank"
      rel="noreferrer"
      className="exclude"
    >
      contact us
    </a>{' '}
    to discuss the options available to you for placing this {words.redemption}.
  </div>
);

export default AddressChangePendingFundNoteTip;
